import { LOGOUT_ACTION } from '~/actions';
import { Box, Center, Column, Text } from '~/commonComponents';
import Footer from '~/commonComponents/footer';
import { useLoading } from '~/hooks';
import { NoOfficeAccessIcon } from '~/images/icons/NoOfficeAccess';
import TopNavBar from '../TopNavBar';
import CustomSpinner from '~/commonComponents/CustomSpinner';

export const NoOfficeAccess = () => {
  const { isLoading } = useLoading([LOGOUT_ACTION]);

  return (
    <Column flex={1} justifyContent="space-between" minHeight={'100%'}>
      <TopNavBar hasOfficeSelected={false} />
      <Box padding={12} flex={1}>
        <Center
          flex={1}
          width="100%"
          boxShadow="0px 2px 4px rgba(111, 131, 141, 0.325068)"
          borderRadius={25}
        >
          <NoOfficeAccessIcon />
          <Column textAlign="center" gap={12} marginTop={32} alignItems="center">
            <Text color="neutral_500" fontSize={22} fontWeight={700}>
              Let’s get you connected!
            </Text>
            <Text>
              You are not linked to any offices yet. Please reach out
              <br />
              to your GoTu regional account manager or
              <br />
              text (786) 460-2170 for assistance.
            </Text>

            <Box marginTop={24}>
              <CustomSpinner isLoading={isLoading} size={24} />
            </Box>
          </Column>
        </Center>
      </Box>
      <Footer />
    </Column>
  );
};
